define((require) => {
    "use strict";

    const InfiniteScrollingCollectionView = require("ui/common/InfiniteScrollingCollectionView");
    const NoResultsItemView               = require("zbone/NoResultsItemView");
    const ChannelSetupItemView            = require("ui/publish/channelSetup/ChannelSetupItemView");

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) channels in Manual Publishing.
     *
     * @see  ChannelCollection
     * @see  InfiniteScrollingCollectionView
     *
     * @class ChannelCollectionView
     */
    return InfiniteScrollingCollectionView.extend("ChannelCollectionView", {

        itemView: ChannelSetupItemView,

        onEmpty() {
            return new NoResultsItemView({type: "Slots"});
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/ChannelCollectionView.js